// extracted by mini-css-extract-plugin
module.exports = {"commentsTextarea":"ModalForm_commentsTextarea__1Fzcs","root":"ModalForm_root__2NjIQ","selectWrapper":"ModalForm_selectWrapper__9b1Lp"};